import styled, { css } from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  MOBILE_BREAKPOINT,
  orangeMui,
} from "@ryde/theme";

export const LayoutRightCrudContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "layout-right-crud-content",
  },
)<{ $hidden?: boolean }>`
  width: 100%;
  background: white;
  padding-top: 0;
  padding-inline-start: 24px;
  padding-inline-end: 0;
  padding-bottom: 10px;
  flex-grow: 1;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 10px;
  }
  label {
    display: flex;
    font-weight: 400;
  }
  .idLabel {
    color: ${deepPurpleMui.A400};
    margin-bottom: 20px;
    font-weight: 600;
  }
  .idLabelAdmin {
    color: ${blueGreyMui._900};
  }
  .label_orange,
  .label_blue_gray {
    display: inline-block;
    margin-bottom: 12px;
    font-weight: 600;
  }
  .label_orange {
    color: ${orangeMui._700};
  }
  .label_blue_gray {
    color: ${blueGreyMui._500};
  }
  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`;

export const FormContentStaticStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "form-content-static",
})<{ $isFlush?: boolean }>`
  margin-top: ${({ $isFlush }) => ($isFlush ? "0" : "15px")};
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;
  height: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 0px;
    padding-top: ${({ $isFlush }) => ($isFlush ? "0" : "15px")};
  }
`;
